module.exports = __webpack_public_path__ + "media/images/site/CENSINO_FUND_1_NOSSA_METODOLOGIA-4f6009f1a911d2221e3253eaee3bc129.jpg";